import React, { useState } from "react";
import { Button, Badge, Form } from "react-bootstrap";
import ChangePasswordModal from "../../modals/settings/general-settings/ChangePasswordModal";
import ChangePhoneModal from "../../modals/settings/general-settings/ChangePhoneModal";
import DeleteAccountModal from "../../modals/settings/general-settings/DeleteAccountModal";
import ActivityModal from "../../modals/settings/general-settings/ActivityModal";


export default function SecurityTab() {
  const [showPassword, setShowPassword] = useState(false);
  const [showPhone, setShowPhone] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [showActivity, setShowActivity] = useState(false);

  return (
    <div className="security-container">
      <h5 className="mb-4 fw-bold">Security Settings</h5>

      {/* PASSWORD */}
      <div className="setting-row">
        <div>
          <h6>Password</h6>
          <p>
            Set a unique password to protect the account{" "}
            <span className="text-muted">
              | Last Changed 03 Jan 2024, 09:00 AM
            </span>
          </p>
        </div>
        <Button className="dark-btn" onClick={() => setShowPassword(true)}>
          Change Password
        </Button>
      </div>

      {/* 2FA */}
      <div className="setting-row">
        <div>
          <h6>Two Factor Authentication</h6>
          <p>Receive codes via SMS or email every time you login</p>
        </div>
        <Button className="dark-btn">Enable</Button>
      </div>

      {/* GOOGLE */}
      <div className="setting-row">
        <div>
          <h6>
            Google Authentication{" "}
            <Badge bg="success" className="ms-2">
              Connected
            </Badge>
          </h6>
          <p>Connect to Google</p>
        </div>
        <Form.Check type="switch" defaultChecked />
      </div>

      {/* PHONE */}
      <div className="setting-row">
        <div>
          <h6>Phone Number Verification ✅</h6>
          <p>
            Verified Mobile Number :{" "}
            <b>+99264710583</b>
          </p>
        </div>
        <div className="d-flex gap-2">
          <Button variant="light">Remove</Button>
          <Button className="dark-btn" onClick={() => setShowPhone(true)}>
            Change
          </Button>
        </div>
      </div>

      {/* EMAIL */}
      <div className="setting-row">
        <div>
          <h6>Email Verification ✅</h6>
          <p>Verified Email : [email protected]</p>
        </div>
        <div className="d-flex gap-2">
          <Button variant="light">Remove</Button>
          <Button className="dark-btn">Change</Button>
        </div>
      </div>

      {/* DEVICE */}
      <div className="setting-row">
        <div>
          <h6>Device Management</h6>
          <p>The devices associated with the account</p>
        </div>
        <Button className="dark-btn">Manage</Button>
      </div>

      {/* ACTIVITY */}
      <div className="setting-row">
        <div>
          <h6>Account Activity</h6>
          <p>The activities of the account</p>
        </div>
        <Button className="dark-btn" onClick={() => setShowActivity(true)}>
          View
        </Button>
      </div>

      {/* DELETE */}
      <div className="setting-row">
        <div>
          <h6>Delete Account</h6>
          <p>Your account will be permanently deleted</p>
        </div>
        <Button className="dark-btn" onClick={() => setShowDelete(true)}>
          Delete
        </Button>
      </div>

      {/* MODALS */}
      <ChangePasswordModal show={showPassword} onHide={() => setShowPassword(false)} />
      <ChangePhoneModal show={showPhone} onHide={() => setShowPhone(false)} />
      <DeleteAccountModal show={showDelete} onHide={() => setShowDelete(false)} />
      <ActivityModal show={showActivity} onHide={() => setShowActivity(false)} />
          <style>
               {

                    `
                    .security-container {
  background: #fff;
  padding: 20px;
  border-radius: 10px;
}

.setting-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 0;
  border-bottom: 1px solid #eee;
}

.setting-row h6 {
  font-weight: 600;
  margin-bottom: 4px;
}

.setting-row p {
  margin: 0;
  font-size: 14px;
  color: #6c757d;
}

.dark-btn {
  background: #111827;
  border: none;
  padding: 6px 14px;
  font-size: 14px;
}

.dark-btn:hover {
  background: #000;
}

/* MOBILE */
@media (max-width: 768px) {
  .setting-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
}`
               }
          </style>
    </div>
  );
}